import { gql } from '@apollo/client'

// NAVIGATOR_NOTES_SAMPLES

export default gql`
  query navigator_note_samples {
    navigator_note_samples {
      edges {
        node {
          id
          note
          name
        }
      }
    }
  }
`
